import ImageFallbackServer from 'atoms/img-fallback-server';
import ImageWithFallback from 'atoms/image-with-fallback';
import PropTypes from 'prop-types';
import React from 'react';


export default function Grid({ breadcrumb, className, estabFallbackImages, getFallbackSrc, handleclick,
  id, images, isIE, partners, showButton, t }) {

  const gridTypes = ['big', 'medium', 'small', 'small-last'];
  const partner = partners[0] ? partners[0].visibleName : '';

  return (
    <div className={ `grid-container ${className}` }>
      { gridTypes.map((gridType, i) => (
        <div key={ gridType } className={ `grid-container__${gridType}` }>
          <div className={ `grid-container__${gridType}__img ${isIE ? '-ie-fallback' : ''}` }>
            {breadcrumb
              ? (
                <ImageFallbackServer
                  alt={ images && images[i] && images[i].alt && images[i].alt }
                  className={ `grid-container__${gridType}__img__item` }
                  divClassName={ `grid-container__${gridType}__img ${isIE ? '-ie-fallback' : ''}` }
                  estabFallbackImages={ estabFallbackImages }
                  getFallbackSrc={ getFallbackSrc }
                  id={ id }
                  index={ i }
                  src={ images && images[i] && images[i].big && images[i].big }
                />
              )
              : (
                <ImageWithFallback
                  className={ `grid-container__${gridType}__img__item` }
                  fallbackSrc={ getFallbackSrc(id, estabFallbackImages, i) }
                  src={ images && images[i] ? images[i] : getFallbackSrc(id, estabFallbackImages, i) }
                />
              )
            }
            {showButton
            && (
              <div className="grid-container__overlay" onClick={ () => handleclick(partners, i + 1) }>
                <span className="grid-container__more-pics">
                  {t("More pictures on {partner}", { partner })}
                </span>
              </div>
            )
            }
          </div>
        </div>
      ))}
    </div>
  );
}

Grid.defaultProps = {
  className: '',
  getFallbackSrc: () => { },
};

Grid.propTypes = {
  breadcrumb: PropTypes.bool.isRequired,
  className: PropTypes.string,
  estabFallbackImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  getFallbackSrc: PropTypes.func,
  handleclick: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({
    alt: PropTypes.string,
    big: PropTypes.string,
  })).isRequired,
  isIE: PropTypes.bool.isRequired,
  partners: PropTypes.arrayOf(PropTypes.shape({
    favicon: PropTypes.string.isRequired,
    handleClickout: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    pricePerNight: PropTypes.number,
    priceTotal: PropTypes.number,
    visibleName: PropTypes.string.isRequired,
  })).isRequired,
  showButton: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};
